import React from "react";
import InfoIcon from "@mui/icons-material/Info";
import ShowDocumentStatus from "./ShowDocumentStatus";

type ReviewPendingTileProps = {
  className?: string;
  customWidth?: number;
};

// Shared "Review Pending" tile shown in place of a system-determined status tile while a
// section awaits manual review (Story 4622). All of ShowDocumentStatus's other props are
// dead when disable={true} (they only feed the editable <select>, which isn't rendered).
const ReviewPendingTile = ({
  className,
  customWidth = 160,
}: ReviewPendingTileProps) => (
  <ShowDocumentStatus
    trn_id={null}
    documentId={null}
    SourceId={null}
    value={null}
    src={null}
    blockStyle={""}
    textStyle={""}
    label={""}
    invalidateQueries={""}
    disable={true}
    className={className}
    customWidth={customWidth}
    statusClassOverride="bg-info-soft text-info-soft text-center"
    statusLabelOverride="Review Pending"
    statusIconOverride={<InfoIcon style={{ fontSize: "18px" }} />}
  />
);

export default ReviewPendingTile;
